import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Container, Row, Col, Table } from "react-bootstrap";


function Main(props) {
    
    const [activeIndex, setActiveIndex] = useState(props.activeIndex);

    const handleToggle = (index) => {
       
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    const OutsourcedPositions = 

    [

        {
                    AdvertisementDate: <> 21.10.2026 </>,
                    NameofthePost: <>Nursing Assistant - On Outsourcing basis</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202715.pdf",
                        Text: "Applications are invited from interested candidates for the following positions on an outsourcing basis for a period of one year. - OIFM/IITT/RECT-OS/26-2027/15.",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202715_Application.pdf",
                            Text: "1. Click here to download application form",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>04 November 2026 </>,

                    Status:[
                        {
                        }
                         ]
         }, 
        {
                    AdvertisementDate: <> 21.10.2026 </>,
                    NameofthePost: <>Full-Time/Hourly Basis Coaches - On Outsourcing basis</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202714.pdf",
                        Text: "Applications are invited from eligible candidates for deployment as Full-Time/Hourly Basis Coaches at Indian Institute of Technology Tirupati, in the Sports Section, for the academic year 2026–27 - OIFM/IITT/RECT-OS/26-2027/14.",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202714_Application.pdf",
                            Text: "1. Click here to download application form",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>04 November 2026 </>,

                    Status:[
                        {
                        }
                         ]
         }, 
        {
                    AdvertisementDate: <> 19.10.2026 </>,
                    NameofthePost: <>Project Associate and Project Assistant - On Outsourcing basis</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202713.pdf",
                        Text: "Applications invited from qualified and experienced candidates for engagement on an outsourcing basis for a period of one year for deployment at IIT Tirupati - OIFM/IITT/RECT-OS/26-2027/13.",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202713_Application.pdf",
                            Text: "1. Click here to download application form",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>31st October 2026 </>,

                    Status:[
                        {
                        }
                         ]
         }, 
        {
                    AdvertisementDate: <> 22.09.2026 </>,
                    NameofthePost: <>Senior Placement Officer (01 Position) <br /> Junior Placement Officer(01 Position) </> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202712.pdf",
                        Text: "Applications are invited from qualified and eligible candidates for engagement to the positions of Senior Placement Officer and Junior Placement Officer on an outsourcing basis for a period of one year, for deployment at IIT Tirupati.  OIFM/IITT/RECT-OS/26-2027/12",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202712_Application_Form.pdf",
                            Text: "1. Click here to download application form",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>  04.10.2026  </>,

                    Status:[
                         {
                    
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202712_Shortlisted.pdf",
                            Text: "Shortlisted candidates",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                            
                       
                             },
                         ]
         },   
        {
                    AdvertisementDate: <> 10.09.2026 </>,
                    NameofthePost: <>AV Support Engineer (01 Positions) <br /> AV Support Assistant(01 Positions) </> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202711.pdf",
                        Text: "Applications invited from eligible candidates for engagement on an outsourcing basis for a period of one year for deployment at IIT Tirupati.  OIFM/IITT/RECT-OS/26-2027/11",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202711_Application_Form_AV_Support_Engineer.pdf",
                            Text: "1. Click here to download application form",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>  20.09.2026  </>,

                    Status:[
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202711_Selected.pdf",
                            Text: "Selected candidates",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             },
                         
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202711_Shortlisted.pdf",
                            Text: "Shortlisted candidates",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             },
                        
                         ]
         },   
        {
                    AdvertisementDate: <> 09.09.2026 </>,
                    NameofthePost: <>Groundsman (01 Positions)</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202710.pdf",
                        Text: "Applications invited from eligible candidates for engagement on an outsourcing basis for deployment at IIT Tirupati for the position of Groundsman at the Institute Sports Section: OIFM/IITT/RECT-OS/26-2027/10",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202710_Application_Form_Groundsman.pdf",
                            Text: "1. Click here to download application form",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>  20.09.2026 </>,

                    Status:[
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202710_Selected.pdf",
                            Text: "Selected candidates",
                            color: {
                            color: "darkgreen",
                            "text-align": "justify"
                                },
                             glowstatus: "yes"
                       
                             },  
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202710_Shortlist.pdf",
                            Text: "Shortlisted candidates",
                            color: {
                            color: "darkgreen",
                            "text-align": "justify"
                                },
                             glowstatus: "yes"
                       
                             },

                         ]
         },  
        {
                    AdvertisementDate: <> 24.08.2026 </>,
                    NameofthePost: <>Nursing Practitioner (02 Positions)</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202709_Notification.pdf",
                        Text: "Walk-in Interview applications are invited for the post of Nursing Practitioner at Health Centre (on contract)- OIFM/IITT/RECT-OS/26-2027/09  ",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202709_Application.pdf",
                            Text: "1. Click here to download application form",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <> Date & Time for Walk-in Interview : 02.09.2026 at 09:00 AM </>,

                    Status:[
                         {
                            Link: "",
                            Text: "",
                            // color: {
                            //     color: "darkgreen",
                            //     "text-align": "justify"
                            // },
                            // glowstatus: "yes"
                       
                             },
                         ]
         },  

         {
                    AdvertisementDate: <> 20.08.2026 </>,
                    NameofthePost: <>Full-Time/Hourly Basis Coaches - On Outsourcing basis</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202708.pdf",
                        Text: "Applications are invited from eligible candidates for deployment as Full-Time/Hourly Basis Coaches at Indian Institute of Technology Tirupati, in the Sports Section, for the academic year 2026–27 - OIFM/IITT/RECT-OS/26-2027/08.",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202708_Application.pdf",
                            Text: "1. Click here to download application form",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>31st August 2026 </>,

                    
                        Status:[
                         {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202708_Selected_Full_Time_Coaches.pdf",
                            Text: "Selected candidates",
                            color: {
                            color: "darkgreen",
                            "text-align": "justify"
                                },
                             glowstatus: "yes"
                       
                             }, 
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202708_Shortlist_Full_Time_Coaches.pdf",
                            Text: "Shortlisted candidates",
                            color: {
                            color: "darkgreen",
                            "text-align": "justify"
                                },
                             glowstatus: "yes"
                       
                             },
                         ]
         },  

        {
                    AdvertisementDate: <> 17.08.2026 </>,
                    NameofthePost: <>Project Associate and Project Assistant - On Outsourcing basis</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202707.pdf",
                        Text: "Applications invited from qualified and experienced candidates for engagement on an outsourcing basis for a period of one year for deployment at IIT Tirupati - OIFM/IITT/RECT-OS/26-2027/07.",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202707_Application.pdf",
                            Text: "1. Click here to download application form",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>31st August 2026 </>,

                    Status:[
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202707_Selected.pdf",
                            Text: "Selected candidates",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             },  
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202707_Shortlist.pdf",
                            Text: "Shortlisted candidates",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             },
                         ]
         }, 
        {
                    AdvertisementDate: <> 24.07.2026 </>,
                    NameofthePost: <>Assistant Manager, Senior Executives and Junior Executives</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202706.pdf",
                        Text: "The advertisement and application form for the post of Assistant Manager, Senior Executives and Junior Executives (on contract) OIFM/IITT/RECT-OS/26-2027/06",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/Application_Form_24_7_26.pdf",
                            Text: "1. Click here to download application form",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>
                        <strong>Date of Selection Process:</strong> 28th August 2026<br/>
                        <strong>Venue:  Administrative Building </strong> - for Assistant Manager (Accounts) Post<br/>
                        <strong>Computer LAB: AB-1</strong> - for Jr. & Sr. Executives Posts<br/>
                        IIT Tirupati<br/>
                        <strong>Reporting Time:</strong> 08:15 AM<br/>
                        <br/><br/>
                    Last date to apply : 04th August 2026 
                    </>,

                    Status:[
                         {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202706_Selected_List_Manager.pdf",
                            Text: "Selected candidates",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             }, 
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-202706_Shortlisted.pdf",
                            Text: "Shortlisted candidates",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             },
                         ]
         },
         {
                    AdvertisementDate: <> 24.07.2026 </>,
                    NameofthePost: <>Institute Counsellor</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-27GCU03.pdf",
                        Text: "The advertisement and application form for the post of Institute Counsellor (on contract)",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/Application_Form_24_7_26.pdf",
                            Text: "1. Click here to download application form",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>09th August 2026 </>,

                    Status:[
                              {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-27GCU03_Selected.pdf",
                            Text: "Selected List",

                             glowstatus: "yes"
                       
                             },
                         {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-27GCU03_Shortlist.pdf",
                            Text: "Shortlisted candidates",
                      
                             },
                       
                         ]
         },
         {
                    AdvertisementDate: <> 24.07.2026 </>,
                    NameofthePost: <>Psychiatric Nurse</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-2705.pdf",
                        Text: "The advertisement and application form for the post of Psychiatric Nurse (on contract)",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/Application_Form_24_7_26.pdf",
                            Text: "1. Click here to download application form",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>09th August 2026 </>,

                    Status:[
                         {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS26-2705_Shortlist.pdf",
                            Text: "Shortlisted candidates",
                            // color: {
                            //     color: "darkgreen",
                            //     "text-align": "justify"
                            // },
                             glowstatus: "yes"
                       
                             },
                         ]
         },

        {
                    AdvertisementDate: <> 15.06.2026 </>,
                    NameofthePost: <>Car Driver</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/pdfs/announcements/2026/Walk-in-Interview_for_Driver_Post_15_06_26.pdf",
                        Text: "The advertisement and application form for the post of Car Driver (on contract)",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2026/Application_Form_Car_Driver_15_06_26.pdf",
                            Text: "1. Click here to download application form",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>: <b>Walk-in Interview on 23/06/2026 at 10:00 AM onwards</b><br />
                                  <b>Venue</b>: Administrative Building, IIT Tirupati </>,
                    Status:[
                         {
                            Link: "",
                            Text: "",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             },
                         ]
         },
        {
                    AdvertisementDate: <> 25.05.2026 </>,
                    NameofthePost: <>Manager</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/pdfs/announcements/2026/OIFMIITTRECT-OS25-202604_Notification.pdf",
                        Text: "The advertisement and application form for the post of Manager (on contract)",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2026/OIFMIITTRECT-OS25-202604_Application_Form.pdf",
                            Text: "1. Click here to download application form",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>:
                     <b>Date of Selection Process</b>: 17th July 2026 <br /><b>Reporting Time</b> : 09:00 AM <b>Venue</b> : Administrative Building, IIT Tirupati, Yerpedu - Venkatagiri Road, Tirupati </>,

                    Status:[
                         {
                            Link: "https://files.iittp.ac.in/2026/recruitment/Outsourced/OIFMIITTRECT-OS25-202604_Selected_List_Manager.pdf",
                            Text: "Selected candidates",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             },
                         {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2026/OIFMIITTRECT-OS25-202604_shortlisted_interview.pdf",
                            Text: "Shortlisted candidates",
                            // color: {
                            //     color: "darkgreen",
                            //     "text-align": "justify"
                            // },
                            // glowstatus: "yes"
                       
                             },
                         ]
         },
         {
                    AdvertisementDate: <> 24.03.2026 </>,
                    NameofthePost: <>Night Duty Doctors, Nursing Practitioner, Nursing Assistant, Ambulance Driver and Car Driver</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/pdfs/announcements/2026/OIFMIITTRECT-OS25-202603_Notification_Health Centre.pdf",
                        Text: "Walk in interview advertisement and application form for the post of Night Duty Doctors, Nursing Practitioner, Nursing Assistant, Ambulance Driver and Car Driver (on contract)",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2026/OIFM-IITTP-RECT-OS-01-2025_Appilcation_Form_Doctor_Nursing_Practitioner.pdf",
                            Text: "1. Click here to download application form for Duty Doctors, Nursing Practitioner, Nursing Assistant",
                            glowstatus : "yes"
                        },
                         {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2026/OIFM-IITTP-RECT-OS-01-2025_Appilcation_Form_Ambulance_Car_Driver.pdf",
                            Text: "2. Click here to download application form for Ambulance Driver and Car Driver",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>Date & Time for Walk-in Interview for Duty Doctors, Nursing Practitioner, Nursing Assistant : 02/04/2026<br /><br />
                                Date & Time for Walk-in Interview for Ambulance Driver and Car Driver : 01/04/2026</>,
                    Status:[
                         {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2026/OIFMIITTRECT-OS25-202603_Selected_List.pdf",
                            Text: "Selected Candidate List",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             },
                         ]
         },
        {
                    AdvertisementDate: <> 18.02.2026 </>,
                    NameofthePost: <>Psychiatric Nurse (01 Position)</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/pdfs/announcements/2026/OIFMIITTRECT-OS25-202602_Notification_Psychiatric_Nurse.pdf",
                        Text: "The advertisement and application form for the post of Psychiatric Nurse (on contract)",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2026/OIFMIITTRECT-OS25-202602_Application_Form.pdf",
                            Text: "Click here to download",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>Last date for application submission : 05/03/2026</>,
                    Status:[
                        
                         ]
         },
         {
                    AdvertisementDate: <> 18.02.2026 </>,
                    NameofthePost: <>Institute Counsellor (02 Positions)</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/pdfs/announcements/2026/OIFMIITTRECT-OS25-202602_Notification_Institute_Counsellor.pdf",
                        Text: "The advertisement and application form for the post of Institute Counsellor (on contract)",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2026/OIFMIITTRECT-OS25-202602_Application_Form.pdf",
                            Text: "Click here to download",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>Last date for application submission : 05/03/2026</>,
                    Status:[
                         {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2026/OIFMIITTRECT-OS25-202602_Institute_Counsellor_Selected_List.pdf",
                            Text: "Selected Candidate List",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             },
                         {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2026/OIFMIITTRECT-OS25-202602_Shortlisted_Institute_Counsellor.pdf",
                            Text: "Shortlisted Candidate List",
                            // color: {
                            //     color: "darkgreen",
                            //     "text-align": "justify"
                            // },
                            // glowstatus: "yes"
                       
                             },
                        
                         ]
         },
        {
                    AdvertisementDate: <> 05.02.2026 </>,
                    NameofthePost: <>Internal Audit Officer (01 Vacancy)</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/pdfs/announcements/2026/IAO_Notification.pdf",
                        Text: "The advertisement and application form for the post of Internal Audit Officer (on contract)",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2026/IAO_Application_Form.pdf",
                            Text: "Click here to download",
                            glowstatus : "yes"
                        },
                        
                    ],
                    LastDate: <>Last date for application submission : 15.02.2026</>,
                    Status:[
                         {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2026/IITTAdmin2025-2601_Selected_Candidate.pdf",
                            Text: "Selected Candidate List",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             },
                         {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2026/IAO_Shortlisted.pdf",
                            Text: <><br/>Shortlisted Candidates List</>,
                            // color: {
                            //         color: "darkgreen",
                            //         "text-align": "justify"
                            //     },
                            // glowstatus: "yes"
                       
                             }, 
                         ]
         },
         {
                    AdvertisementDate: <> 10.12.2025 </>,
                    NameofthePost: <>Nursing Practitioner (03 Vacancies),<br/> Nursing Assistant (03 Vacancies) & <br/> Ambulance Driver (04 Vacancies)</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/pdfs/announcements/2025/OIFM-IITTP-RECT-OS-01-2025_Notification.pdf",
                        Text: "Notification for the position of Nursing Pracitioner, Nursing Assistant & Ambulance Driver (Outsourced Position) - OIFM/IITTP/RECT-OS/01/2025",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                        {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2025/OIFM-IITTP-RECT-OS-01-2025_Notification_Appilcation-Form_Nursing-Practitioner.pdf",
                            Text: "Click here to download (Nursing Practitioner & Nursing Assistant)",
                            glowstatus : "yes"
                        },
                        {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2025/OIFM-IITTP-RECT-OS-01-2025_Notification_Appilcation-Form_Nursing_Ambulance-Driver.pdf",
                            Text: <><br/>Click here to download (Ambulance Driver)</>,
                            glowstatus : "yes"
                        }
                        // {
                        //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                        //     Text: "2. Representation Status",
                        //     glowstatus : "yes"
                        // }
                    ],
                    LastDate: <>Last date for submission application : 21.12.2025</>,
                    Status:[
                        {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2026/OIFMIITTPRECT-OS012025_Selected_List_Ambulance_Driver.pdf",
                            Text: "Selected Candidates List (Ambulance Driver)",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             },
                        {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2025/OIFMIITTPRECT-OS012025_Selected_List-NP-NA.pdf",
                            Text: "Selected Candidates List (Nursing Practitioner & Nursing Assistant)",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             },
                        
                             {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2025/OIFMIITTPRECT-OS012025_Shortlisted_Candidates-Driver.pdf",
                            Text: <><br/>Shortlisted Candidates List (Ambulance Driver)</>,
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             }, 
                             {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2025/OIFMIITTPRECT-OS012025_Shortlisted_Candidates.pdf",
                            Text: <><br/>Shortlisted Candidates List (Nursing Practitioner & Nursing Assistant)</>,
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "no"
                       
                             },
                        
                         ]
         },
         {
                    AdvertisementDate: <> 26.08.2025 </>,
                    NameofthePost: <>Tennis and Gym Trainer (01 Position)</> ,
                    Advertisement: {
                        Link: "https://files.iittp.ac.in/pdfs/announcements/2025/ITTSPORTS04COACH.AD2025_Notification.pdf",
                        Text: "Notification for the position of Coaches, Tennis and Gym Trainer (Outsourced Position) - ITT/SPORTS/04/COACH.AD/2025",
                        Style: {
                            color: "blue"
                        }
                       
                    },
                    Application: [
                       {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/ITTSPORTS04COACH.AD2025_Application_Form.pdf",
                    Text: "Click here to download",
                    glowstatus : "yes"
                }
                        // {
                        //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                        //     Text: "2. Representation Status",
                        //     glowstatus : "yes"
                        // }
                    ],
                    LastDate: <>Last date for submission application : 02.09.2025</>,
                    Status:[
                        {
                            Link: "https://files.iittp.ac.in/pdfs/announcements/2025/ITTSPORTS04COACH_AD2025_Shortlisted.pdf",
                            Text: "Shortlisted Candidates List",
                            color: {
                                color: "darkgreen",
                                "text-align": "justify"
                            },
                            glowstatus: "yes"
                       
                             },
                         ]
                },

        {
            AdvertisementDate: <> 11.08.2025 </>,
            NameofthePost: <>Assistant Manager & Senior Executive </> ,
            Advertisement: 
                {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSAT2025-26094_Notification.pdf",
                Text: "Notification for the position of Assistant Manager & Senior Executive - HoME Section (Outsourced Position) - IITT/SAT/2025-26/094",
                glowstatus : "yes",
            
                Style: {
                    color: "maroon",
                },
            },
        
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSAT2025-26094_Application_Form.pdf",
                    Text: "Click here to download",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 25.08.2025</>,
            Status:[
                 {
                Link: "",
                Text: <><br /><br /></>,
                // color: {
                //     color: "darkgreen",
                //     "text-align": "justify"
                // },
                // glowstatus: "yes",
            },
            
            // {
            //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITT_SPORTS_03_COACH_AD_2025_shortlisted.pdf",
            //     Text: "Shortlisted Candidates List",
            //     color: {
            //         color: "",
            //         "text-align": "justify"
            //     },
            //     glowstatus: "no"
            // }
               
            ]
            },
        {
            AdvertisementDate: <> 21.05.2025 </>,
            NameofthePost: <>Coaches, Gym Trainer and Groundsman </> ,
            Advertisement: 
                {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSPORTS03COACH.AD2025_Notification.pdf",
                Text: "Notification for the position of Coaches, Gym Trainer and Groundsman (Outsourced Position) - IITT/SPORTS/03/COACH.AD/2025",
                // glowstatus : "yes",
            
                // Style: {
                //     color: "maroon"!
                // },
            },
        
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSPORTS03COACH.AD2025_Application_Form.pdf",
                    Text: "Click here to download (Applications are now closed)",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 28.05.2025</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITT_SPORTS_03_COACH_AD_2025_Selected.pdf",
                Text: <>Selected Candidates List<br /><br /></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                },
                glowstatus: "no",
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITT_SPORTS_03_COACH_AD_2025_shortlisted.pdf",
                Text: "Shortlisted Candidates List",
                color: {
                    color: "",
                    "text-align": "justify"
                },
                glowstatus: "no"
            }
               
            ]
            },

        {
            AdvertisementDate: <> 30.04.2025 </>,
            NameofthePost: <>Ambulance Driver (01 Position)</> ,
            Advertisement: 
                {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2025-2613_Notification.pdf",
                Text: "Notification for the position of Ambulance Driver (Outsourced Position) - IITT/STFM/REC-OS/2025-26/13",
                // glowstatus : "yes",
            
                // Style: {
                //     color: "maroon"
                // },
            },
        
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2025-2613_Application_Form.pdf",
                    Text: "Click here to download (Applications are now closed)",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 15.05.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 11.04.2025 </>,
            NameofthePost: <>Junior Executive Assistant (01)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2025-2612_JEA_Notification.pdf",
                Text: "Notification for the position of Junior Executive Assistant (Outsourced Position) - IITT/STFM/REC-OS/2025-26/12",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2025-2612_JEA_Application_Form.pdf",
                    Text: "Click here to download (Applications are now closed)",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 20.04.2025</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2512_Selected_list.pdf",
                Text: <>Selected Candidates List<br /><br /></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                },
                glowstatus: "yes",
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2512_Shortlisted.pdf",
                Text: "Shortlisted Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 25.02.2025 </>,
            NameofthePost: <>Junior Executive Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2511_Notification_JEA.pdf",
                Text: "Notification for the position of Junior Executive Assistant (Outsourced Position) - IITT/STFM/REC-OS/2024-25/11",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2511_Application_Form_JEA.pdf",
                    Text: "Click here to download (Applications are now closed)",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 10.03.2025</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2511_Selected_List.pdf",
                Text: <>Selected Candidates List<br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2511_Shortlisted.pdf",
                Text: "Shortlisted Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 20.02.2025 </>,
            NameofthePost: <>Project Officer (01), Project Associate (02)</> ,
            Advertisement: [
                {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2510_Notification_CC_positions.pdf",
                Text: "Notification for Various Positions in the CC Department (Outsourced Positions) - IITT/STFM/RECT-OS/2024-25/10",
                
                
                // glowstatus : "yes",
            
                // Style: {
                //     color: "maroon"
                
                // },
               
            },
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2510_Rescheduled_Date.pdf",
                Text: "*Note: Due to administrative reasons the date of the selection process is postponed to 9th May 2025.",
                 
                
                // glowstatus : "yes",
            
                // Style: {
                //     color: "maroon"
                // },
               
            },
        ],
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2510_Application_Form.pdf",
                    Text: "Click here to download (Applications are now closed)",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Selection process date: <s>08-05-2025</s><br /> 09-05-2025<br /><br />Last date for submission application : 07.03.2025</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS102025_Selected_list.pdf",
                Text: <>Selected Candidates List<br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify",
                },
                glowstatus: "yes",
            },
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2510_Rescheduled_Date.pdf",
                    Text: <>Corrigendum<br/><br/></>,
                    color: {
                        color: "darkgreen",
                        "text-align": "justify",
                    },
                    // glowstatus: "yes",
                },
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2510_Shortlisted.pdf",
                Text: <>Shortlisted Candidates List<br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify",
                },
                // glowstatus: "yes",
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2510_Syllabus.pdf",
                Text: <>Syllabus</>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify",
                },
                // glowstatus: "yes",
            }
        ]
        },
        {
            AdvertisementDate: <> 12.02.2025 </>,
            NameofthePost: <>Electrician cum plumber (1)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSAT2024-25063_Notification_Electrician_cum_plumber.pdf",
                Text: "Notification for the position of Electrician cum plumber (1) - Hostels (Outsourced Position) - IITT/SAT/2024-25/063",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSAT2024-25063_Application_Form_Electrician_cum_plumber.pdf",
                    Text: "Click here to download (Applications are now closed)",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 04.03.2025</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSAT2024-25063_Selected_Electrician_cum_plumber_Hostels.pdf",
                Text: <>Selected Candidate List<br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSAT2024-25063_Shortlist_Electrician_cum_plumber_Hostels.pdf",
                Text: "Shortlisted Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 12.02.2025 </>,
            NameofthePost: <>Caretaker (1)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSAT2024-25062_Notification_Caretaker.pdf",
                Text: "Notification for the position of Caretaker (1) - Hostels (Outsourced Position) - IITT/SAT/2024-25/062",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSAT2024-25062_Application_Form_Caretaker.pdf",
                    Text: "Click here to download (Applications are now closed)",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 04.03.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 30.01.2025 </>,
            NameofthePost: <>Senior Executive Assistant (1)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2509_Senior_Executive_Assistant_Notification.pdf",
                Text: "Notification for the position of Senior Executive Assistant (1) - Accounts Section (Outsourced Position) - IITT/STFM/REC-OS/2024-25/09",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2509_Application_Form_for_Senior_Executive_Assistant.pdf",
                    Text: "Click here to download (Applications are now closed)",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 09.02.2025</>,
            Status:[
                 {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2508_Selected_List.pdf",
                    Text: <>Selected Candidates List<br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2509_Shortlisted_SEA.pdf",
                Text: "Shortlisted Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 17.01.2025 </>,
            NameofthePost: <>Project Associate - Civil (02) & Environmental Manager cum Plant Operator (01)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2507_Notification_Project_Associate_Environmental_Manager.pdf",
                Text: " Notification for the position of Project Associate - Civil (02) & Environmental Manager cum Plant Operator (01) - Engineering Unit (Outsourced Position) - IITT/STFM/REC-OS/2024-25/07",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2507_Application_Form.pdf",
                    Text: "Click here to download (Applications are now closed)",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 30.01.2025</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2507_Selected_list.pdf",
                Text: <>Selected Candidates List <br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2507_Shortlisted_Rev_18.pdf",
                Text: <>Shortlisted Candidates List</>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 10.01.2025 </>,
            NameofthePost: <>Junior Executive Assistant - Accounts (2)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2506_Junior_Executive_Notification.pdf",
                Text: "Notification for the position of Junior Executive Assistant (2) - Accounts (Outsourced Position) - IITT/STFM/REC-OS/2024-25/07 ",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2507_Application_Form_JEA.pdf",
                    Text: "Click here to download (Applications are now closed)",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 20.01.2025</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2508_Selected_List.pdf",
                Text: <>Selected Candidates List<br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2508_Shortlisted_JEA.pdf",
                Text: <>Shortlisted Candidates List</>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 30.12.2024 </>,
            NameofthePost: <>Junior Executive Assistant (3)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2506_Junior_Executive_Notification.pdf",
                Text: "Notification for the position of Junior Executive Assistant (3) - Outsourced Position - IITT/STFM/REC-OS/2024-25/06 ",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2506_Application_Form.pdf",
                    Text: "Click here to download (Applications are now closed)",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 10.01.2025</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFPRECT-OS2024-2506_Selected_list.pdf",
                Text: <>Selected Candidates List<br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2506_Shortlisted_JEA.pdf",
                Text: <>Shortlisted Candidates List</>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },

        {
            AdvertisementDate: <> 17.12.2024 </>,
            NameofthePost: <>Program Administrator (1)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMREC-OS2024-2505.pdf",
                Text: "Notification for the position of Program Administrator for Global Engagement, Alumni and Corporate Relations - IAA office (Outsourced Position) - IITT/STFM/REC-OS/2024-25/05 ",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Click here to download (Applications are now closed)",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 06.01.2025</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2505.pdf",
                Text: <>Selected Candidates List<br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMRECT-OS2024-2505_Shortlisted_PA.pdf",
                Text: <>Shortlisted Candidates List</>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        }
          

        

    ]


   
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Outsourced Positions" />
            <section className="project-detail">
                <div className="container">
                    <div className="c-heading">
                        <h1>Outsourced Positions</h1>
                    </div>

                    <Row>
                        <div className="card-body">

                            
                                    <Table bordered responsive className="mt-3 table table-striped">
                                    <thead>
                                        <tr className='c-tablehead'>
                                        <th>
                                        Date
                                            </th>
                                            <th>
                                                Name of the Post
                                            </th>
                                            <th>Advertisement</th>
                                            <th>
                                                Application
                                            </th>
                                            <th>
                                                Last Date
                                            </th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                    
                                    <tbody>
                                        {OutsourcedPositions.map((item, index) => (
                                            <tr key={index}>
                                                 <td>{item.AdvertisementDate}</td>
                                                <td>{item.NameofthePost}</td>
                                                <td>
                                                    {Array.isArray(item.Advertisement) ? (
                                                        item.Advertisement.map((Advertisement, idx) => (
                                                            <div key={idx}>
                                                                <a className={`text-maroon ${Advertisement.glowstatus === "yes" ? 'glowing-text' : ''}`} href={Advertisement.Link} style={{ color: (Advertisement.color || (Advertisement.Style && Advertisement.Style.color)) }} target="_blank" >
                                                                {Advertisement.Text}
                                                                <span> (Click Here <i className="icon fas fa-file-pdf" style={{color:"red"}}></i>)</span>
                                                                </a>
                                                            </div>
                                                        ))
                                                    ) : (
                                                            <a className={`text-marron ${item.Advertisement.glowstatus == "yes" ? 'glowing-text' : ''}`} href={item.Advertisement.Link} style={{ color: (item.Advertisement.Style && item.Advertisement.Style.color) }} target="_blank" >
                                                            {item.Advertisement.Text}
                                                            <span> (Click Here <i className="icon fas fa-file-pdf" style={{color:"red"}}></i>)</span>
                                                        </a>
                                                    )
                                                    
                                                    }
                                                </td>
                                                {/* <td>
                                                    {typeof item.Advertisement === 'string' ? item.Advertisement : (
                                                        <a className={`text-marron ${item.Status.glowstatus == "yes" ? 'glowing-text' : ''}`} href={item.Advertisement.Link} style={{ color: (item.Advertisement.Style && item.Advertisement.Style.color) }} target="_blank" >
                                                            {item.Advertisement.Text}
                                                            <span> (Click Here <i className="icon fas fa-file-pdf" style={{color:"red"}}></i>)</span>
                                                        </a>
                                                    )}
                                                </td> */}
                                                <td>
                                                    {item.Application.map((status, i) => (
                                                        <div key={i}>
                                                            <a className={`text-maroon ${status.glowstatus === "yes" ? 'glowing-text' : ''}`} href={status.Link} target="_blank" >{status.Text}</a>
                                                        </div>
                                                    ))}
                                                </td>
                                                <td><span><i className="icon fas fa-calendar" style={{color:"steelblue"}}> </i> </span> {item.LastDate}</td>
                                                <td>
                                                    {Array.isArray(item.Status) ? (
                                                        item.Status.map((Status, idx) => (
                                                            <div key={idx}>
                                                                <a className={`text-maroon ${Status.glowstatus === "yes" ? 'glowing-text' : ''}`} href={Status.Link} style={{ color: (Status.color || (Status.Style && Status.Style.color)) }} target="_blank" >
                                                                {Status.Text}
                                                               
                                                                </a>
                                                            </div>
                                                        ))
                                                    ) : (
                                                            <a className={`text-marron ${item.Status.glowstatus == "yes" ? 'glowing-text' : ''}`} href={item.Status.Link} style={{ color: (item.Status.Style && item.Status.Style.color) }} target="_blank" >
                                                            {item.Status.Text}
                                                            
                                                        </a>
                                                    )
                                                    
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                            
                                    </Table>     
                        </div>
   
                    </Row>
                </div>
            </section>
        </>
    );
}

export default Main;
